const Fonts = Object.freeze({
  extraBold: 'OpenSans Extra Bold',
  semiBold: 'OpenSans Semi Bold',
  light: 'OpenSans Light',
  timesNewRoman: 'Times New Roman',
});

export default Fonts;
